<div class="wrapper flex flex-col flex-1 min-h-0 h-full">
    <router-outlet></router-outlet>
</div>
